// extracted by mini-css-extract-plugin
export default {"root":"classes_root__o+yFn","infos-container":"classes_infos-container__oaT01","col":"classes_col__6H9Xj","button-container":"classes_button-container__6iqHI"};